import React, { useContext, useEffect, useState } from 'react';
import { getSaleItems } from '../services/salesServices';
import { addScrap } from '../services/catalogServices';
import Toast from '../helpers/Toast';
import Spinner from '../helpers/Spinner';
import '../../styles/sales.css';
import Product from '../sales/Product';
import { AuthContext } from '../../context/Auth.context';
import { Link } from 'react-router-dom';
import beep_file from '../../assets/sounds/beep.wav';
import { getID } from '../functions/getID';

let beep = new Audio(beep_file);

const Scrap = () => {

    const cartInitialValue = { productList: [], payment: 0, total: 0, discount: 0, paymentMethod: 1, change: 0, notes: '', split: false, payInDlls: false, paymentDlls: 0, changeDlls: 0, totalDlls: 0, partial: false, secondPaymentMethod: 0, secondPayment: 0, date: '' };
    const [saleitems, setSaleItems] = useState([]);
    const [defaultPaymentMethod, setDefaultPaymentMethod] = useState(0);
    const [subtotal, setSubTotal] = useState(0);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [cart, setCart] = useState(cartInitialValue);
    const { state, CheckResponse, setConfig } = useContext(AuthContext);


    useEffect(() => {
        loadSaleItems();
    }, []);


    useEffect(() => {
        let newTotal = 0;
        cart.productList.map(product => {
            newTotal += product.qty * product.price;
        });
        setSubTotal(newTotal);

    }, [cart]);

    const numberPrice = (n) => {
        return parseFloat(n).toFixed(2);
    }

    const cleanCart = () => {
        setCart({ ...cart, productList: [], payment: 0, total: 0, discount: 0, paymentMethod: defaultPaymentMethod, change: 0, notes: '', split: false, payInDlls: false, paymentDlls: 0, changeDlls: 0, totalDlls: 0, partial: false, secondPaymentMethod: defaultPaymentMethod, secondPayment: 0 });
    }

    const showToast = (t, d, tt, dd = 5) => {
        setList([...list, {
            id: getID(),
            title: t,
            description: d,
            type: tt,
            short: true,
            delete: dd
        }]);
    }

    const loadSaleItems = () => {
        setLoading(true);
        getSaleItems(state.auth).then(data => {
            CheckResponse(data);
            if (data.code == 200) {
                if (data.data.length > 0) {
                    setSelectedCategory(data.data[0].name);
                }
                setSaleItems(data.data);
                setCart({ ...cart, paymentMethod: data.payments[0].id });
                setDefaultPaymentMethod(data.payments[0].id);
                setConfig(data.config);
            } else {
                showToast('Oops!', 'Algo salio mal!', 'danger');
            }

            setLoading(false);
        });
    }

    const addProductToCart = (prd) => {
        let newCart = cart.productList;

        const objWithIdIndex = newCart.findIndex((obj) => obj.id === prd.id);

        if (objWithIdIndex > -1) {
            newCart[objWithIdIndex].qty = newCart[objWithIdIndex].qty + 1;
            setCart({ ...cart, productList: newCart });
        } else {
            newCart.unshift({ id: prd.id, name: prd.name, price: prd.price, qty: 1 });
            setCart({ ...cart, productList: newCart });
        }
        beep.play();
    }

    const ProductRemoveFromCart = (id) => {
        let newCart = cart.productList;

        const objWithIdIndex = newCart.findIndex((obj) => obj.id === id);

        if (objWithIdIndex > -1) {
            newCart.splice(objWithIdIndex, 1);
            setCart({ ...cart, productList: newCart });
        }
    }

    const ProductUpdateQty = (id, type) => {
        let newCart = cart.productList;
        const objWithIdIndex = newCart.findIndex((obj) => obj.id === id);

        if (objWithIdIndex > -1) {

            beep.play();

            if (type == 'up') {
                newCart[objWithIdIndex].qty += 1;
                setCart({ ...cart, productList: newCart });
            }
            if (type == 'down') {
                let newQty = newCart[objWithIdIndex].qty - 1;

                if (newQty < 0) {
                    ProductRemoveFromCart(id);
                } else {
                    newCart[objWithIdIndex].qty = newQty;
                    setCart({ ...cart, productList: newCart });
                }
            }
        }
    }

    const scrapAdd = () => {
        setLoading(true);
        let error = false;
        if (!error) {
            addScrap(state.auth, cart.productList).then(data => {
                CheckResponse(data);
                if (data.code == 200) {
                    cleanCart();
                    setLoading(false);
                    showToast('Hecho!', 'Guardado con exito', 'success');
                } else {
                    showToast('Oops!', 'Algo salio mal!', 'danger');
                    setLoading(false)
                }
            });
        }
    }

    return (
        <>
            {/* lista de desperdicios */}
            {!loading && <div>
                <Toast toastList={list} />
                <div className="row">
                    {saleitems.length > 0 && <div className="col-sm-8">
                        <div className="row">
                            <div className="col-sm-12">
                                {saleitems.map(category =>
                                    <button key={category.name} className={`btn ${selectedCategory == category.name ? 'btn-light' : 'btn-primary'}  ms-1 mb-1`} type="button" onClick={() => { setSelectedCategory(category.name) }}>
                                        {category.name}
                                    </button>
                                )}
                            </div>
                        </div>
                        {saleitems.map(category =>
                            <div key={category.name} className={`row mt-2 collapse ${selectedCategory == category.name ? 'show' : ''}`}>
                                <>
                                    {category.products.length > 0 && category.products && category.products.map && category.products.map(product =>
                                        <Product key={product.id} add={addProductToCart} product={product}></Product>
                                    )}
                                    {category.products.length == 0 &&
                                        <div className="col-sm-12 text-center">
                                            <h2 className=' mt-4'>No hay productos</h2>
                                            <Link to="/catalogs/product/" className="btn btn-primary mt-2">Agregar</Link>
                                        </div>}
                                </>
                            </div>
                        )}

                    </div>}
                    {saleitems.length == 0 && <div className="col-sm-8 text-center">
                        <h2 className=' mt-4'>No hay categorias</h2>
                        <Link to="/catalogs/category/" className="btn btn-primary mt-2">Agregar</Link>
                    </div>}
                    <div className="col-sm-4">
                        <div className="row mt-4">
                            <div className="col-sm-12">
                                <div className="d-grid gap-2">
                                    <button onClick={() => { scrapAdd() }} className={`btn btn-success ${subtotal > 0 ? '' : 'disabled'}`} type="button"><i className="bi bi-bucket"></i> Agregar a desperdicios</button>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-sm-12 text-wrap text-center">
                                <h4>Lista de desperdicios</h4>
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col-sm-12 text-wrap">
                                <ul id="scrollable" style={{ "height": "500px", "overflow": "auto" }} className="list-group">
                                    {cart.productList.map(product =>
                                        <div key={product.id}>
                                            {product.id > 0 && <li className="list-group-item d-flex justify-content-between align-items-center p-1">
                                                <table className='ms-2' style={{ "width": "100%" }}>
                                                    <tbody>
                                                        <tr style={{ "width": "100%" }}>
                                                            <td style={{ "width": "100%" }}>{product.name}</td>
                                                        </tr>
                                                        <tr style={{ "width": "100%" }}>
                                                            <td style={{ "width": "80%" }}>
                                                                <div className="input-group input-group-sm">
                                                                    <button onClick={() => { ProductUpdateQty(product.id, 'down') }} className="btn btn-outline-danger btn-sm" type="button"><i className="bi bi-dash-square"></i></button>
                                                                    <input onChange={() => { }} value={product.qty} type="numer" className="form-control form-control-sm" style={{ "maxWidth": "80px", "textAlign": "center" }}></input>
                                                                    <button onClick={() => { ProductUpdateQty(product.id, 'up') }} className="btn btn-outline-success btn-sm" type="button"><i className="bi bi-plus-square"></i></button>
                                                                    <span className="input-group-text ms-4">$ {numberPrice(product.qty * product.price)}</span>
                                                                </div>
                                                            </td>
                                                            <td style={{ "textAlign": "center", "width": "20%" }}>
                                                                <button onClick={() => { ProductRemoveFromCart(product.id) }} type="button" className="btn btn-danger btn ms-2"><i className="bi bi-trash"></i></button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </li>}
                                        </div>
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-12">
                                <div className="col-sm-12 text-wrap text-center">
                                    <h5>Total: ${numberPrice(subtotal)}</h5>
                                </div>
                                {cart.productList.length > 1 &&
                                    <div className="d-grid gap-2">
                                        <button onClick={() => { cleanCart() }} className={`btn btn-danger`} type="button"><i className="bi bi-trash"></i> Limpiar Lista de Productos</button>
                                    </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>}

            {loading && <Spinner size={8} margin={4}></Spinner>}
        </>
    );
}

export default Scrap;